import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import QRCode from 'qrcode';

const QRCodePage = () => {
  const { redemptionCode } = useParams();
  const [qrCodeUrl, setQrCodeUrl] = useState('');

  useEffect(() => {
    generateQRCode();
  }, [redemptionCode]);

  const generateQRCode = async () => {
    try {
      const validationUrl = `${window.location.origin}/redeem/${redemptionCode}`;
      const qrDataUrl = await QRCode.toDataURL(validationUrl, {
        width: 400,
        margin: 2,
        color: {
          dark: '#000000',
          light: '#FFFFFF'
        }
      });
      setQrCodeUrl(qrDataUrl);
    } catch (error) {
      console.error('Error generating QR code:', error);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-emerald-50 to-teal-50 flex items-center justify-center p-6">
      <Card className="max-w-md w-full p-8">
        <div className="text-center space-y-6">
          {/* Header */}
          <div>
            <div className="flex justify-center mb-4">
              <div className="w-20 h-20 bg-gradient-to-r from-green-400 to-emerald-500 rounded-full flex items-center justify-center">
                <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z" />
                </svg>
              </div>
            </div>
            <h1 className="text-3xl font-bold text-gray-900 mb-2">
              🎉 Félicitations !
            </h1>
            <p className="text-gray-600">
              Vous avez gagné un cadeau !
            </p>
          </div>

          {/* QR Code */}
          <div className="bg-white p-8 rounded-2xl border-4 border-green-200 shadow-lg">
            {qrCodeUrl ? (
              <img 
                src={qrCodeUrl} 
                alt="QR Code" 
                className="w-full h-auto"
              />
            ) : (
              <div className="w-full h-64 flex items-center justify-center">
                <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-green-500"></div>
              </div>
            )}
          </div>

          {/* Instructions */}
          <div className="bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-200 rounded-xl p-6">
            <p className="text-lg font-semibold text-gray-900 mb-3">
              📱 Scannez ce QR Code en magasin
            </p>
            <div className="text-sm text-gray-700 space-y-2 text-left">
              <p>1️⃣ Présentez ce QR code au commerçant</p>
              <p>2️⃣ Il scannera le code avec son téléphone</p>
              <p>3️⃣ Votre cadeau s'affichera et sera validé</p>
            </div>
          </div>

          {/* Warning */}
          <div className="bg-orange-50 border border-orange-200 rounded-lg p-4">
            <p className="text-sm text-orange-900 font-medium">
              ⚠️ Ce QR code ne peut être utilisé qu'une seule fois
            </p>
          </div>

          {/* Footer */}
          <p className="text-xs text-gray-500 mt-6">
            Code: {redemptionCode.slice(-8)}
          </p>
        </div>
      </Card>
    </div>
  );
};

export default QRCodePage;
